module.exports = __webpack_public_path__ + "img/arrow-right-white.2afa4299.svg";